import { render, staticRenderFns } from "./_accessDirect.vue?vue&type=template&id=3249bf5f&"
import script from "./_accessDirect.vue?vue&type=script&lang=js&"
export * from "./_accessDirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports